module.exports = __webpack_public_path__ + "static/media/Workday_Step3_Image3g.e6da1f73.jpg";